module.exports = (
) ->
  return {
    restrict: 'A'
    scope:
      callback: "&ngOnload"

    link: (scope, element, attrs) ->
      element.on("load", ->
        scope.callback(true)
      )
  }
